import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form, Table, Dropdown } from "react-bootstrap";
import DataTable, { createTheme } from 'react-data-table-component';
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import config from "../../../../config";
import config1 from "../../../../coreFIles/config";
import Header from "../../../commanComponents/usernavbar"

import "../../css/staffdashboard.css"
import "../../css/finance.css"

import ListMenuButton from "./listMenu";
import UserNameAndTab from "./UserNameAndTab";

import { getPropertyList, checkProfitAndLoss } from '../../../../Action/propertyOwner.action'
import colors from "react-multi-date-picker/plugins/colors";


const Profitloss = () => {


    useEffect(() => {
        // Add the class to the body tag
        document.body.classList.add('staffbody');

        // Cleanup function to remove the class when the component is unmounted
        return () => {
            document.body.classList.remove('staffbody');
        };
    }, []);


    const getFirstDateOfMonth = () => {
        const today = new Date();
        const firstDate = new Date(today.getFullYear(), today.getMonth(1), 1);
        return firstDate.toISOString().split('T')[0];
    };

    const getCurrentDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    const [propertyList, setPropertyList] = useState([])
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [profitAndLoss, setProfitAndLoss] = useState([])

    useEffect(() => {
        fetchPropertyList()
    }, [formData, fromDate, toDate]);

    const fetchPropertyList = async () => {
        try {
            let res = await getPropertyList()
            if (res.success) {
                setPropertyList(res.data || [])
                handleSubmit()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = async () => {
        try {
            let data = {
                ...formData,
                fromDate,
                toDate,
            }

            let res = await checkProfitAndLoss(data)
            if (res.success) {
                setProfitAndLoss(res.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFormData((old) => {
            return { ...old, [name]: value };
        });
        if (value.trim() !== "") {
            setErrors((oldErrors) => ({ ...oldErrors, [name]: "" }));
        }
    };

    const columns = [
        {
            name: 'Exp name',
            selector: row => row.expname,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true,
        },
        {
            name: 'Tax',
            selector: row => row.tax,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.year,
            sortable: true,
        },
        {
            name: 'Total',
            selector: row => row.total,
            sortable: true,
        },
    ];

    const data = [
        {
            id: 1,
            expname: 'Clearing',
            amount: '$10',
            tax: '$1',
            date: '14/08/2024',
            year: 'Paid',
            total: '$11'
        },
        {
            id: 2,
            expname: 'Putty',
            amount: '$10',
            tax: '$2',
            date: '-',
            year: '-',
            total: '$12'
        },

    ]

    return (
        <div className="staffdashboard bg-pink">
            <Header />
            <section className="listing pt-5 pb-5 overflow-hidden vh-80">
                <Container>

                    <UserNameAndTab />
                    <div className="listMenuButton">
                        <Col xl={12} lg={12} className="mb-3">
                            <Card className="border-0 tablistfinance">
                                <Card.Body>
                                    <ListMenuButton />
                                </Card.Body>
                            </Card>
                        </Col>
                    </div>
                    <div className="">
                        <Col lg={12} className="mb-3">
                            <Card className="border-0 bg-white p-3">
                                <Card.Header className="border-0 mb-0">
                                    <div className="d-sm-flex justify-content-between align-items-center">
                                        <div className="mb-4"><h4 className="mb-0 fw-bolder">Profit and Loss Report </h4></div>
                                        <div className="">

                                        </div>
                                    </div>

                                </Card.Header>
                                <Card.Body className="p-0">
                                    <div className="">
                                        <Row>
                                            <Col lg={12}>
                                                <Form.Group
                                                    className="me-2"
                                                    controlId="formBasicPassword"
                                                >
                                                    <label className="text-light-grey">Report Period</label>
                                                    <Row className="mt-2">

                                                        <Col lg={6} className="mb-4">
                                                            <Form.Group controlId="formBasicExpense">
                                                                {/* <Form.Label className="text-light-grey mb-1">Property</Form.Label> */}
                                                                <Form.Control
                                                                    as="select"
                                                                    name="propertyId"
                                                                    onChange={inputHandler}
                                                                >
                                                                    <option value="">Select Property</option>
                                                                    {propertyList.map(item => (
                                                                        <option key={item.id} value={item.id}>
                                                                            {item.propertyName}
                                                                        </option>
                                                                    ))}
                                                                </Form.Control>
                                                                {errors.pvid && <small className="text-danger">{errors.pvid}</small>}
                                                            </Form.Group>
                                                        </Col>


                                                        <Col lg={3} className="mb-4">
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder="Date"
                                                                    aria-label="firstName"
                                                                    name="Date"
                                                                    onChange={(e) => setFromDate(e.target.value)}
                                                                />
                                                                <span className="text-light-grey inner-field small">From</span>
                                                            </div>
                                                        </Col>

                                                        <Col lg={3} className="mb-4">
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder="Date"
                                                                    aria-label="firstName"
                                                                    name="Date"
                                                                    onChange={(e) => setToDate(e.target.value)}
                                                                />
                                                                <span className="text-light-grey inner-field small">To</span>
                                                            </div>
                                                        </Col>

                                                        <Col lg={3}>

                                                        </Col>
                                                        <Col lg={12}>
                                                            <hr className="mb-4 mt-0" style={{ color: "#EBEBEB", opacity: "1" }} />
                                                        </Col>
                                                        {/* <Col lg={6} className="mb-4">
                                                            <Form.Group className="" controlId="formBasicEmail">
                                                                <Form.Label className="text-light-grey mb-1">Display Column By</Form.Label>
                                                                <Form.Control type="text" placeholder="" />
                                                            
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={6} className="mb-4">
                                                            <Form.Group className="" controlId="formBasicEmail">
                                                                <Form.Label className="text-light-grey mb-1">Show Non Zero or Active Only</Form.Label>
                                                                <Form.Control type="text" placeholder="" />
                                                           
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={6} className="mb-4">
                                                            <Form.Group className="" controlId="formBasicEmail">
                                                                <Form.Label className="text-light-grey mb-1">Compare Another Period </Form.Label>
                                                                <Form.Control type="text" placeholder="" />
                                                               
                                                            </Form.Group>
                                                        </Col> */}
                                                        {/* <Col lg={6} className="mb-4">
                                                            <Form.Group className="radiobtn" controlId="formBasicEmail">
                                                                <Form.Label className="text-light-grey mb-1">Accounting Method</Form.Label>
                                                                <Row className="mt-2">
                                                                    <Col lg={6}>
                                                                        <Form>
                                                                            {['radio'].map((type) => (
                                                                                <div key={`inline-${type}`} className="mb-3">
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="Cash"
                                                                                        name="group1"
                                                                                        type={type}
                                                                                        id={`inline-${type}-1`}
                                                                                    />
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="Accrual"
                                                                                        name="group1"
                                                                                        type={type}
                                                                                        id={`inline-${type}-2`}
                                                                                    />
                                                                                </div>
                                                                            ))}
                                                                        </Form>
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <Button
                                                                            variant="primary"
                                                                            className=" rounded-5 me-2 px-4 px-xs-1 w-100 "
                                                                        >
                                                                            Run Report
                                                                        </Button>
                                                                    </Col>
                                                                </Row>

                                                            </Form.Group>
                                                        </Col> */}
                                                    </Row>

                                                </Form.Group>

                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="tableCard">
                                        {/* <div className="tableHeader border-0 px-sm-4 bg-light-grey pb-sm-0">
                                            <div className="align-items-center d-sm-flex justify-content-between">
                                                <div>
                                                    <div className="d-flex gap-md-5 align-items-center justify-content-between mb-3">
                                                        <div className="mb-0 me-2">
                                                        </div>
                                                        <div className="mb-0 me-2">

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-end mb-sm-3">

                                                    <div>
                                                        <div className="d-inline-block">
                                                            <Button
                                                                variant="default"
                                                                className="me-4 p-0 h-auto"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5975 12.8664C20.5975 14.9105 18.9659 16.5706 16.9627 16.5706H5.03738C3.03415 16.5706 1.40251 14.9104 1.40251 12.8664V5.13354C1.40251 4.45133 1.5858 3.81057 1.90396 3.26064L7.72276 9.19058C8.5933 10.0803 9.75907 10.5706 11.0013 10.5706C12.2409 10.5706 13.4067 10.0803 14.2772 9.19058L20.096 3.26064C20.4142 3.81057 20.5974 4.45128 20.5974 5.13354V12.8664H20.5975ZM16.9626 1.4293H5.03738C4.21013 1.4293 3.44648 1.71462 2.83559 2.18933L8.71294 8.18153C9.32132 8.79888 10.1333 9.14131 11.0013 9.14131C11.8667 9.14131 12.6787 8.79888 13.287 8.18153L19.1644 2.18933C18.5535 1.71462 17.7899 1.4293 16.9626 1.4293ZM16.9626 0H5.03738C2.26034 0 0 2.30351 0 5.13359V12.8664C0 15.6991 2.26034 18 5.03738 18H16.9626C19.7397 18 22 15.6991 22 12.8664V5.13354C22 2.30346 19.7397 0 16.9626 0Z" fill="black" />
                                                                </svg>
                                                            </Button>
                                                        </div>
                                                        <div className="d-inline-block">
                                                            <Button
                                                                variant="default"
                                                                className="me-4 p-0 h-auto"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M17.0703 5.03906H16.5234V2.92969C16.5234 1.31426 15.2092 0 13.5938 0H6.40625C4.79082 0 3.47656 1.31426 3.47656 2.92969V5.03906H2.92969C1.31426 5.03906 0 6.35332 0 7.96875V12.6562C0 14.2717 1.31426 15.5859 2.92969 15.5859H3.47656V18.2422C3.47656 19.2114 4.26512 20 5.23438 20H14.7656C15.7349 20 16.5234 19.2114 16.5234 18.2422V15.5859H17.0703C18.6857 15.5859 20 14.2717 20 12.6562V7.96875C20 6.35332 18.6857 5.03906 17.0703 5.03906ZM4.64844 2.92969C4.64844 1.96043 5.43699 1.17188 6.40625 1.17188H13.5938C14.563 1.17188 15.3516 1.96043 15.3516 2.92969V5.03906H4.64844V2.92969ZM15.3516 18.2422C15.3516 18.5653 15.0887 18.8281 14.7656 18.8281H5.23438C4.91129 18.8281 4.64844 18.5653 4.64844 18.2422V12.4609H15.3516V18.2422ZM18.8281 12.6562C18.8281 13.6255 18.0396 14.4141 17.0703 14.4141H16.5234V12.4609H16.875C17.1986 12.4609 17.4609 12.1986 17.4609 11.875C17.4609 11.5514 17.1986 11.2891 16.875 11.2891H3.125C2.80141 11.2891 2.53906 11.5514 2.53906 11.875C2.53906 12.1986 2.80141 12.4609 3.125 12.4609H3.47656V14.4141H2.92969C1.96043 14.4141 1.17188 13.6255 1.17188 12.6562V7.96875C1.17188 6.99949 1.96043 6.21094 2.92969 6.21094H17.0703C18.0396 6.21094 18.8281 6.99949 18.8281 7.96875V12.6562Z" fill="black" />
                                                                    <path d="M11.5625 13.7891H8.4375C8.11391 13.7891 7.85156 14.0514 7.85156 14.375C7.85156 14.6986 8.11391 14.9609 8.4375 14.9609H11.5625C11.8861 14.9609 12.1484 14.6986 12.1484 14.375C12.1484 14.0514 11.8861 13.7891 11.5625 13.7891Z" fill="black" />
                                                                    <path d="M11.5625 16.2891H8.4375C8.11391 16.2891 7.85156 16.5514 7.85156 16.875C7.85156 17.1986 8.11391 17.4609 8.4375 17.4609H11.5625C11.8861 17.4609 12.1484 17.1986 12.1484 16.875C12.1484 16.5514 11.8861 16.2891 11.5625 16.2891Z" fill="black" />
                                                                    <path d="M5 7.53906H3.125C2.80141 7.53906 2.53906 7.80141 2.53906 8.125C2.53906 8.44859 2.80141 8.71094 3.125 8.71094H5C5.32359 8.71094 5.58594 8.44859 5.58594 8.125C5.58594 7.80141 5.32359 7.53906 5 7.53906Z" fill="black" />
                                                                </svg>
                                                            </Button>
                                                        </div>
                                                        <div className="d-inline-block">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="default" id="dropdown-basic" className="me-4 p-0 h-auto">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <path d="M19.8248 5.81599L14.4081 0.191033C14.2314 0.00777613 13.9606 -0.0497491 13.7248 0.0451599C13.4882 0.140984 13.3332 0.37017 13.3332 0.625142V3.33356H13.1249C8.64493 3.33356 4.99994 6.97855 4.99994 11.4585V12.7085C4.99994 12.9984 5.2041 13.2401 5.48654 13.306C5.53247 13.3176 5.57824 13.3226 5.62402 13.3226C5.85992 13.3226 6.08575 13.1843 6.19485 12.9668C7.36656 10.6226 9.72235 9.16679 12.3432 9.16679H13.3332V11.8751C13.3332 12.1302 13.4882 12.3594 13.7248 12.4543C13.9591 12.5501 14.2314 12.4918 14.4081 12.3084L19.8248 6.68345C20.0581 6.44099 20.0581 6.05937 19.8248 5.81599Z" fill="black" />
                                                                        <path d="M17.4999 20.0004H2.49998C1.12167 20.0004 0 18.8789 0 17.5004V5.83397C0 4.45565 1.12167 3.33398 2.49998 3.33398H4.99996C5.46077 3.33398 5.83324 3.70645 5.83324 4.16726C5.83324 4.62807 5.46077 5.00054 4.99996 5.00054H2.49998C2.03993 5.00054 1.66655 5.37392 1.66655 5.83397V17.5004C1.66655 17.9605 2.03993 18.3339 2.49998 18.3339H17.4999C17.9598 18.3339 18.3331 17.9605 18.3331 17.5004V10.8339C18.3331 10.3731 18.7056 10.0005 19.1664 10.0005C19.6274 10.0005 19.9998 10.3731 19.9998 10.8339V17.5004C19.9998 18.8789 18.8782 20.0004 17.4999 20.0004Z" fill="black" />
                                                                    </svg>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className="d-inline-block">
                                                            <Button
                                                                variant="default"
                                                                className="p-0 h-auto "
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M19.4111 11.5896L18.5527 10.9047C17.9646 10.4355 17.9657 9.56352 18.5527 9.09527L19.4111 8.41035C20.0219 7.92289 20.1782 7.08703 19.7826 6.42277L18.0876 3.57723C17.6919 2.91301 16.8667 2.62629 16.1259 2.89527L15.0847 3.27336C14.3715 3.53227 13.5929 3.09559 13.4679 2.36863L13.2851 1.30559C13.1551 0.549102 12.4863 0 11.695 0H8.30503C7.5137 0 6.84493 0.549102 6.71487 1.30562L6.53206 2.36863C6.40685 3.09687 5.62716 3.53184 4.91531 3.2734L3.87411 2.89527C3.13324 2.62629 2.30817 2.91305 1.91245 3.57723L0.217469 6.42273C-0.178176 7.08691 -0.0219654 7.92281 0.588972 8.41031L1.44736 9.09523C2.03545 9.56445 2.03428 10.4364 1.44736 10.9047L0.588932 11.5896C-0.0219653 12.0771 -0.178216 12.913 0.217428 13.5772L1.91245 16.4227C2.30813 17.0869 3.13304 17.3737 3.87411 17.1047L4.91527 16.7266C5.62857 16.4676 6.40705 16.9046 6.53202 17.6313L6.71483 18.6943C6.84493 19.4509 7.5137 20 8.30499 20H11.695C12.4863 20 13.155 19.4509 13.2851 18.6944L13.4679 17.6314C13.5931 16.9034 14.3727 16.4681 15.0847 16.7267L16.1259 17.1047C16.8669 17.3738 17.6919 17.087 18.0876 16.4228L19.7826 13.5772C20.1782 12.913 20.0219 12.0771 19.4111 11.5896ZM16.6915 15.6415L15.6503 15.2634C13.9858 14.6591 12.1694 15.6787 11.8778 17.3745L11.695 18.4375H8.30503L8.12222 17.3745C7.83007 15.6754 6.01096 14.6603 4.34975 15.2634L3.30855 15.6415L1.61357 12.796L2.47196 12.1111C3.8442 11.0161 3.84134 8.9816 2.47196 7.88895L1.61357 7.20402L3.30859 4.35848L4.34975 4.73656C6.01422 5.34086 7.83063 4.32133 8.12222 2.62551L8.30499 1.5625H11.695L11.8778 2.62551C12.1699 4.3248 13.9891 5.33961 15.6502 4.73656L16.6914 4.35848L18.3868 7.20363C18.3868 7.20363 18.3867 7.20375 18.3864 7.20398L17.528 7.88891C16.1558 8.98375 16.1586 11.0183 17.528 12.111L18.3864 12.7959L16.6915 15.6415ZM10 6.14582C7.80738 6.14582 6.02353 7.8748 6.02353 10C6.02353 12.1252 7.80738 13.8542 10 13.8542C12.1926 13.8542 13.9765 12.1252 13.9765 10C13.9765 7.8748 12.1926 6.14582 10 6.14582ZM10 12.2917C8.69628 12.2917 7.63561 11.2636 7.63561 10C7.63561 8.73637 8.69628 7.70832 10 7.70832C11.3037 7.70832 12.3644 8.73637 12.3644 10C12.3644 11.2636 11.3037 12.2917 10 12.2917Z" fill="black" />
                                                                </svg>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div> */}
                                        {/* ----------Balance sheet----------- */}
                                        <div className="tableBody p-0" >
                                            <div className="text-center pt-5">
                                                <h4 className="mb-1">{profitAndLoss.propertyName}</h4>
                                                <div className="mb-1 fs-5">Profit & Loss A/c</div>
                                                {fromDate && (
                                                    <p className="text-grey fs-5">
                                                        As of {new Date(fromDate).toLocaleDateString('en-GB')}
                                                        {toDate && ` to ${new Date(toDate).toLocaleDateString('en-GB')}`}
                                                    </p>
                                                )}

                                            </div>

                                            <div className="tableContent">
                                                {/* <DataTable
                                                    columns={columns}
                                                    data={data}
                                                /> */}
                                                <ul className="mb-0 list-unstyled ps-0 mt-4">


                                                    <li>
                                                        <div className="block">
                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-2">
                                                                    <h5 className="mb-0">Income</h5>
                                                                </div>

                                                            </div>
                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-2">
                                                                    <p className="mb-0">Property Booking</p>
                                                                </div>
                                                                <div className="text-end mb-2">
                                                                    <h5 className="mb-0" style={{ color: 'green' }}>${profitAndLoss.totalBookingAmount || '0.00'}</h5>
                                                                </div>
                                                            </div>

                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-2">
                                                                    <p className="mb-0">Property Manual Booking</p>
                                                                </div>
                                                                <div className="text-end mb-2">
                                                                    <h5 className="mb-0" style={{ color: 'green' }}>${profitAndLoss.totalManualBookingAmount || '0.00'}</h5>
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <li>
                                                                <div className="block">

                                                                    <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                        <div className="mb-1">
                                                                            <h5 className="mb-0">Total booking amount</h5>
                                                                        </div>
                                                                        <div className="text-end mb-1">
                                                                            <h5 className="mb-0" style={{ color: 'green' }}>${profitAndLoss.totalIncomeOnBooking || '0.00'}</h5>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </li>

                                                            <hr />

                                                            <div className="text-center pt-5">
                                                                <div className="mb-1 fs-5">Expense List</div>

                                                            </div>


                                                        </div>
                                                    </li>



                                                    <li>

                                                        <Row>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Exp Name</h6>
                                                                    </div>

                                                                </div>

                                                            </Col>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Amount</h6>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Tax</h6>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Date</h6>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Status</h6>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                            <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                <div className="d-sm-flex justify-content-between list-unstyled">
                                                                    <div className="mb-2">
                                                                        <h6 className="mb-0">Total</h6>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </li>
                                                    <li>
                                                        {profitAndLoss.expenseDetails?.map((item) => {
                                                            return (
                                                                <Row>
                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="">
                                                                                <p className="mb-0">{item.expenseName}</p>
                                                                            </div>

                                                                        </div>

                                                                    </Col>
                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="mb-2">
                                                                                <p className="mb-0">${item.expenseAmount}</p>
                                                                            </div>

                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="mb-2">
                                                                                <p className="mb-0">${item.taxAmount}</p>
                                                                            </div>

                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="mb-2">
                                                                                <p className="mb-0">
                                                                                    {new Date(item.paymentDate).toLocaleDateString('en-GB', {
                                                                                        day: '2-digit',
                                                                                        month: '2-digit',
                                                                                        year: 'numeric',
                                                                                    })}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </Col>

                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="mb-2">
                                                                                <p
                                                                                    className="mb-0"
                                                                                    style={{
                                                                                        color:
                                                                                            item.paymentStatus === 0
                                                                                                ? 'orange'
                                                                                                : item.paymentStatus === 1
                                                                                                    ? 'green'
                                                                                                    : item.paymentStatus === 2
                                                                                                        ? 'red'
                                                                                                        : item.paymentStatus === 3
                                                                                                            ? 'purple'
                                                                                                            : 'black',
                                                                                    }}
                                                                                >
                                                                                    {item.paymentStatus === 0 && 'Pending'}
                                                                                    {item.paymentStatus === 1 && 'Paid'}
                                                                                    {item.paymentStatus === 2 && 'Unpaid'}
                                                                                    {item.paymentStatus === 3 && 'Overdue'}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </Col>

                                                                    <Col lg={2} md={4} sm={6} xs={6} className="">
                                                                        <div className="d-sm-flex justify-content-between list-unstyled">
                                                                            <div className="mb-2">
                                                                                <p className="mb-0">${item.expenseAmount + item.taxAmount}</p>
                                                                            </div>

                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                    </li>


                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0">Total Expense</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0" style={{ color: 'red' }}>${profitAndLoss.totalExpenseAmount || '0.00'}</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>


                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0">Net Profit</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0" style={{ color: 'green' }}>${profitAndLoss.totalIncomeOnBooking > profitAndLoss.totalExpenseAmount ? profitAndLoss.totalIncomeOnBooking - profitAndLoss.totalExpenseAmount : '0.00'}</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0">Net Loss</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0" style={{ color: 'red' }}>
                                                                        {profitAndLoss.totalIncomeOnBooking < profitAndLoss.totalExpenseAmount
                                                                            ? `-$${Math.abs(profitAndLoss.totalIncomeOnBooking - profitAndLoss.totalExpenseAmount).toFixed(2)}`
                                                                            : `$0.00`}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>

                                                </ul>

                                            </div>
                                            {/* ----------No data Found-------------- */}
                                            <div className="text-center py-5 my-5 d-none">
                                                <div>
                                                    <img src="images/nodatafound.svg" />
                                                </div>
                                                <h5 className="mb-1">Profit and Loss Report</h5>
                                                <p className="text-grey mb-1">1 January - 8 June 2024</p>
                                                <div>This report doesn’t have any data</div>
                                            </div>
                                            {/* ----------No data Found-------------- */}

                                        </div>
                                        {/* ----------Statement Of Cash Flow----------- */}
                                        <div className="tableBody p-0 d-none" >
                                            <div className="text-center pt-5">
                                                <h4 className="mb-1">Nick’s Maintenance & Supplies </h4>
                                                <div className="mb-1 fs-5">Statement Of Cash Flow </div>
                                                <p className="text-grey fs-5">As of Now 8 June 2024</p>

                                            </div>
                                            <div className="tableContent">
                                                <ul className="mb-0 list-unstyled ps-0">
                                                    <li>
                                                        <div className="block">
                                                            <h5 className="mb-2">Assets</h5>
                                                            <div>
                                                                <p className="mb-2">Cashflow form operating activities </p>
                                                                <ul className="d-sm-flex justify-content-between mb-0">
                                                                    <li className="border-0 p-0 mb-2">
                                                                        Profit of the year
                                                                    </li>
                                                                    <li className="text-end list-unstyled border-0 p-0 mb-2">
                                                                        <h5 className="mb-0">$98,06,500.00</h5>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <p className="mb-2">Adjustment of non cash income & expenses  </p>
                                                            <div>
                                                                <p className="mb-2">Accounts Receivable A/R </p>
                                                                <ul className="d-sm-flex justify-content-between mb-0">
                                                                    <li className="border-0 p-0 mb-1">
                                                                        Inventory Assets
                                                                    </li>
                                                                    <li className="text-end list-unstyled border-0 p-0 mb-1">
                                                                        <h5 className="mb-0">-$98,06,500.00</h5>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0">Total Adjustment of non cash income & expenses</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0">-$16,98,06,500.00</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-2">
                                                                    <p className="mb-0">Net Cash from operating activites</p>
                                                                </div>
                                                                <div className="text-end mb-2">
                                                                    <h5 className="mb-0">$0</h5>
                                                                </div>
                                                            </div>
                                                            <div className="d-sm-flex justify-content-between">
                                                                <div className="mb-2">
                                                                    Cashflow from net Activities
                                                                </div>
                                                                <div className="text-end mb-2">
                                                                    <h5 className="mb-0">$0</h5>
                                                                </div>
                                                            </div>
                                                            <ul className="d-sm-flex justify-content-between mb-0">
                                                                <li className="mb-1 border-0 p-0">
                                                                    Opening Balance Activity
                                                                </li>
                                                                <li className="text-end mb-1 border-0 p-0 list-unstyled">
                                                                    <h5 className="mb-0">$0</h5>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>

                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0">Net Cash Used in financing Activities</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0">$16,846,170.00</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled mb-0">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0 text-uppercase">Net Cash increase (DESCRESE IN CASH AND CASH EQUIVALANET) </h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0">$16,846,170.00</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="block">

                                                            <div className="d-sm-flex justify-content-between list-unstyled">
                                                                <div className="mb-1">
                                                                    <h5 className="mb-0 text-uppercase">CASH AND CASH EQUIVALENTS'S AT THE END OID THE YEAR</h5>
                                                                </div>
                                                                <div className="text-end mb-1">
                                                                    <h5 className="mb-0">$16,846,170.00</h5>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>

                                                </ul>
                                            </div>


                                        </div>

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </div>



                </Container>
            </section>
        </div >
    );
};

export default Profitloss;